import axios from 'axios'

export default {
    GETALLEXPERTS ({ commit }) {
        return axios.get('/experts').then((response) => {
            const { data: { data } } = response
            commit('setAllExperts', {experts: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETALLEXPERTS_CORPORATION ({ commit }, corporationId) {
        return axios.get(`/experts/getAllExperts/${corporationId}`).then((response) => {
            const { data: { data } } = response
            commit('setAllExperts', {experts: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETEXPERT ({ commit }, expertId) {
        return axios.get(`/experts/${expertId}`).then((response) => {
            const { data: { data } } = response
            commit('setExpert', {expert: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GET_EXPERT_BY_BY_ID ({ commit }, expertId) {
        return axios.get(`/experts/getExpertById/${expertId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setExpert', {expert: data.payload})
            } else {
                commit('setExpert', {expert: null})
            }
        }, (err) => {
            commit('setExpert', {expert: null})
            console.log('err ', err)
        })
    },
    GET_EXPERT_NEXT_EVENT ({ commit }, expertId) {
        return axios.get(`/events/getExpertNearestEvent/${expertId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setExpertNextEvent', {event: data.payload})
            } else {
                commit('setExpertNextEvent', {event: null})
            }
        }, (err) => {
            commit('setExpertNextEvent', {event: null})
            console.log('err ', err)
        })
    },
    GETEXPERTVIDEOS ({ commit }, expertId) {
        return axios.get(`/playlists/getExpertVideosById/${expertId[0]}/${expertId[1]}/10`).then((response) => {
            const { data: { data } } = response
            if (data && data.length > 0) {
                commit('setExpertVideos', {expertVideos: data})
                commit('setComingVideoFlag', false)
            } else {
                commit('setComingVideoFlag', true)
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETEXPERTPLAYLIST ({ commit }, expertId) {
        return axios.get(`/playlists/getExpertContentVideosById/${expertId[0]}/${expertId[1]}`).then((response) => {
            const { data: { data } } = response
            if (data && data.length > 0) {
                commit('setExpertPlaylist', {playList: data})
            } else {
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GET_EXPERT_EVENT_CLIPS ({ commit }, expertId) {
        // events/getExpertEventsVideos
        return axios.get(`/events/getToneLiveEventsForExperts/${expertId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setExpertArchiveClips', {clips: data.payload})
            } else {
                commit('setExpertArchiveClips', {clips: null})
            }
        }, (err) => {
            commit('setExpertArchiveClips', {clips: null})
            console.log('err ', err)
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/experts/actions.js